import { InjectionToken } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AppSettingsService, AuthConfig } from 'shared';

import { AuthConfigRepositoryService } from '../repositories';

export function AuthConfigInitializerFactory<TAppSettings>(
    appSettingsService: AppSettingsService<TAppSettings>,
    authConfigRepository: AuthConfigRepositoryService,
    mapConfig: (appSettings: TAppSettings) => AuthConfig
) {
    // Initialize auth service
    return (): Observable<void> =>
        appSettingsService.appSettings.pipe(
            take(1),
            switchMap((appSettings) => from(authConfigRepository.initialize(mapConfig(appSettings))))
        );
}

export const MAP_AUTH_CONFIG = new InjectionToken<<TAppSettings>(appSettings: TAppSettings) => AuthConfig>(
    'Map auth config from appsettings'
);
